import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publishPcmpMisBatch } from '../api/pcmpMis.api';
import type { PcmpMisPublishResult } from '../types/pcmpMis.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function usePublishPcmpMisBatch(
  batchNo: number,
  onSuccess: (result: PcmpMisPublishResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (comment: string) => publishPcmpMisBatch(batchNo, comment),
    ...pcmpActionCallbacks<PcmpMisPublishResult>(
      queryClient,
      `Batch #${batchNo} published`,
      onSuccess,
    ),
  });
}
